var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdminView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.151,
    height: 16.921,
    viewBox: "0 0 21.151 16.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-lock",
    "data-name": "Icon awesome-user-lock",
    d: "M7.4,8.46a4.23,4.23,0,1,0-4.23-4.23A4.23,4.23,0,0,0,7.4,8.46Zm3.173,2.115a2.085,2.085,0,0,1,.268-1.008,4.523,4.523,0,0,0-.479-.05H9.812a5.753,5.753,0,0,1-4.819,0H4.442A4.443,4.443,0,0,0,0,13.959v1.376a1.586,1.586,0,0,0,1.586,1.586H10.87a2.1,2.1,0,0,1-.294-1.058Zm9.518-1.058H19.036V6.874a2.644,2.644,0,1,0-5.288,0V9.518H12.691a1.058,1.058,0,0,0-1.058,1.058v5.288a1.058,1.058,0,0,0,1.058,1.058h7.4a1.058,1.058,0,0,0,1.058-1.058V10.576A1.058,1.058,0,0,0,20.094,9.518Zm-3.7,4.759a1.058,1.058,0,1,1,1.058-1.058A1.058,1.058,0,0,1,16.392,14.277ZM17.45,9.518H15.335V6.874a1.058,1.058,0,1,1,2.115,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdminView);
export default __webpack_public_path__ + "static/media/icon-admin-view.d00d279bd9fd48a969897bf5eb2d69c3.svg";
export { ForwardRef as ReactComponent };